<p-table #dt [value]="medicalExamCertificateHistory" dataKey="id">
    <ng-template pTemplate="emptymessage">
        <tr>
            <td [attr.colspan]="12">
                No Records Found
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="header" let-expanded="expanded" let-data>
        <tr>
            <th class="w--arrow"></th>
            <th pSortableColumn="businessTransactionNumberId">Id <p-sortIcon field="id"></p-sortIcon></th>
            <th pSortableColumn="businessTransactionNumberId">Decision <p-sortIcon field="decisionDisplayValue"></p-sortIcon></th>
            <th pSortableColumn="businessTransactionNumberId">Restrictions <p-sortIcon field="restrictionDisplayValues"></p-sortIcon></th>
            <th pSortableColumn="businessTransactionNumberId">Is Long <p-sortIcon field="isLongMedicalExamForm"></p-sortIcon></th>
            <th pSortableColumn="businessTransactionNumberId">Registry Code <p-sortIcon field="medicalExaminerRegistryCode"></p-sortIcon></th>
            <th pSortableColumn="businessTransactionNumberId">Issuing State <p-sortIcon field="jurisdictionDisplayValue"></p-sortIcon></th>
            <th pSortableColumn="businessTransactionNumberId">Sign Date <p-sortIcon field="medicalExamCertificateSignatureDate"></p-sortIcon></th>
            <th pSortableColumn="businessTransactionNumberId">Expiration Date <p-sortIcon field="expirationDate"></p-sortIcon></th>
            <th pSortableColumn="businessTransactionNumberId">Status <p-sortIcon field="driverMedicalCertificateStatusTypeDisplayValue"></p-sortIcon></th>
            <th pSortableColumn="businessTransactionNumberId">Status Date <p-sortIcon field="qualificationStatusDate"></p-sortIcon></th>
            <th pSortableColumn="businessTransactionNumberId">Updated Date <p-sortIcon field="updatedDate"></p-sortIcon></th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-data>
        <tr>
            <td class="text-center" [pRowToggler]="data">
                <a href="javascript:void(0)">
                    <i [ngClass]="dt.isRowExpanded(data) ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"></i>
                </a>
            </td>
            <td>{{ data.id }}</td>
            <td>{{ data.decisionDisplayValue }}</td>
            <td class="td--hover-show">{{ data.restrictionDisplayValues }}</td>
            <td>{{ data.isLongMedicalExamForm }}</td>
            <td>{{ data.medicalExaminerRegistryCode }}</td>
            <td>{{ data.jurisdictionDisplayValue }}</td>
            <td>{{ data.medicalExamCertificateSignatureDate | shortDate }}</td>
            <td>{{ data.expirationDate | shortDate }}</td>
            <td>{{ data.driverMedicalCertificateStatusTypeDisplayValue }}</td>
            <td>{{ data.qualificationStatusDate | shortDate }}</td>
            <td>{{ data.updatedDate | shortDate }}</td>
        </tr>
    </ng-template>
    <ng-template pTemplate="rowexpansion" let-data>
        <tr class="mvd_table__sub-container--aligned mvd_table__parent">
            <td colspan="4" class="subtable">
                <h2>Medical Examiner</h2>
                <ul class="list--align-definition__border">
                    <li><b>Name:</b> {{ data.medicalExaminerDisplayName }}</li>
                    <li><b>License Number:</b> {{ data.medicalExaminerLicenseNumber }}</li>
                    <li><b>Specialty Code:</b> {{ data.medicalExaminerSpecialtyCodeDisplayValue }}</li>
                    <li><b>Telephone Number:</b> {{ data.medicalExaminerPhoneNumber | phoneNumberUSA }}</li>
                </ul>
            </td>
            <td colspan="8" class="subtable">
                <h2>Details</h2>
                <ul class="list--align-definition__border">
                    <li><b>Decision:</b> {{ data.decisionDisplayValue }}</li>
                    <li><b>Signature Date:</b> {{ data.medicalExamCertificateSignatureDate | shortDate }}</li>
                    <li><b>Expiration Date:</b> {{ data.expirationDate | shortDate }}</li>
                    <li><b>Restrictions:</b> {{ data.restrictionCodesDisplayValues || 'None' }}</li>
                    <li><b>Exemption Effective Date:</b> {{ data.speCertificateEffectiveDate || 'NA' }}</li>
                    <li><b>Exemption Expiration Date:</b> {{ data.speCertificateEndDate || 'NA' }}</li>
                </ul>
            </td>
        </tr>
    </ng-template>
</p-table>